<!-- Booking Dates Midwife Modal Starts -->
<div class="modal booking-detail fade" id="booking-details-midwife" data-keyboard="false" tabindex="-1"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body p-4" *ngIf="bookingDetails">
                <span class="modal-title mt-3">Booking details</span>
                <div class="d-flex flex-column mt-2">
                    <div class="d-flex flex-row">
                        <img class="profile-img" [src]="bookingDetails.mumBooked[0].profileImage"
                            *ngIf="bookingDetails.mumBooked[0].profileImage">
                        <img class="profile-img" *ngIf="bookingDetails.mumBooked[0].profileImage==undefined"
                            src="../../../../../../assets/Images/pro-pic.png">
                        <div class="d-flex flex-column">
                            <span class="title ml-3 mt-2">{{bookingDetails.mumBooked[0].name}}</span>
                            <span class="section-text ml-3">Due on: {{bookingDetails.mumBooked[0].dueDate |
                                date:'EEE
                                dd
                                MMM'}}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-3 mb-2">
                        <i class="fas fa-phone icon phone"></i>
                        <span class="section-text ml-3">{{bookingDetails.mumBooked[0].user[0].userPhonenumber}}</span>
                    </div>
                    <div class="d-flex flex-row my-2">
                        <i class="fas fa-envelope icon"></i>
                        <span class="section-text ml-3">{{bookingDetails.mumBooked[0].user[0].userEmail}}</span>
                    </div>
                    <div class="d-flex flex-row my-2">
                        <i class="fas fa-map-marker-alt icon pl-1"></i>
                        <span class="section-text ml-3">{{bookingDetails.mumBooked[0].address}}</span>
                    </div>
                    <div class="divider">
                        <div class="d-flex flex-row justify-content-between mb-3">
                            <span class="booking-title">Booked dates</span>
                            <span class="edit-dates" data-toggle="modal" data-dismiss="modal"
                                data-target="#edit-booking-dates">EDIT DATES</span>
                        </div>
                        <div class="wrapper">
                            <button class="btn date-item w-100" *ngFor="let bdate of bookingDates"
                                [ngClass]="{'due-date': checkDueDate(bdate)}">
                                <span *ngIf="checkDueDate(bdate)">Due: </span>{{bdate | date:'EEE dd MMM,
                                yyyy'}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Booking Dates Modal Midwife Ends -->

<!-- Booking Dates Modal Mum Starts -->
<div class="modal booking-detail fade" id="booking-details-mum" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body p-4" *ngIf="bookingDetailMum">
                <span class="modal-title mt-3">Booking details</span>
                <div class="d-flex flex-column mt-2">
                    <div class="d-flex flex-row">
                        <img class="profile-img" [src]="bookingDetailMum.midwifeBooked[0].profileImage"
                            *ngIf="bookingDetailMum.midwifeBooked[0].profileImage">
                        <img class="profile-img" *ngIf="bookingDetailMum.midwifeBooked[0].profileImage==undefined"
                            src="../../../../../../assets/Images/pro-pic.png">
                        <span class="title ml-3 mt-2">{{bookingDetailMum.midwifeBooked[0].name}}</span>
                    </div>
                    <div class="d-flex flex-row mt-3 mb-2">
                        <i class="fas fa-phone icon phone"></i>
                        <span
                            class="section-text ml-3">{{bookingDetailMum.midwifeBooked[0].user[0].userPhonenumber}}</span>
                    </div>
                    <div class="d-flex flex-row my-2">
                        <i class="fas fa-envelope icon"></i>
                        <span class="section-text ml-3">{{bookingDetailMum.midwifeBooked[0].user[0].userEmail}}</span>
                    </div>
                    <div class="d-flex flex-row my-2">
                        <i class="fas fa-map-marker-alt icon pl-1"></i>
                        <span class="section-text ml-3">{{bookingDetailMum.midwifeBooked[0].address}}</span>
                    </div>
                    <div class="divider">
                        <span class="booking-title">Booked dates</span>
                        <div class="wrapper mt-2">
                            <button class="btn date-item w-100" *ngFor="let bdate of bookingDates"
                                [ngClass]="{'due-date': checkDueDate(bdate)}">
                                <span *ngIf="checkDueDate(bdate)">Due: </span>{{bdate | date:'EEE dd MMM,
                                yyyy'}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Booking Dates Modal Mum Ends -->

<!-- Approve Booking Dates Modal Starts -->
<div class="modal booking fade" id="edit-booking-dates" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <form [formGroup]="bookingForm">
                    <div class="d-flex flex-column px-3">
                        <div class="d-flex flex-row justify-content-between mt-3 mb-1">
                            <span class="modal-title">Update booking Dates</span>
                            <i class="fas fa-times modal-close" data-dismiss="modal"></i>
                        </div>
                        <span class="mt-2 mb-4 modal-text" *ngIf="bookingDetails!=undefined">Due on:
                            {{bookingDetails.mumBooked[0].dueDate | date:'EEE dd
                            MMM yyyy'}}</span>
                        <span class="title mb-2">From</span>
                        <div class="d-flex flex-row justify-content-between">
                            <select name="from day" id="from-day" class="form-control form-control-sm"
                                (change)="validateDate()" formControlName="fromDay">
                                <option [value]="day" *ngFor="let day of fromDaysDrop">{{day}}</option>
                            </select>
                            <select name="from month" id="from-month" class="form-control form-control-sm mx-2"
                                (change)="validateDate()" formControlName="fromMonth">
                                <option [value]="month.no" *ngFor="let month of months">{{month.text}}</option>
                            </select>
                            <select name="from year" id="from-year" class="form-control form-control-sm"
                                (change)="validateDate()" formControlName="fromYear">
                                <option [value]="year" *ngFor="let year of years">{{year}}</option>
                            </select>
                        </div>
                        <span *ngIf="fromDateError" class="error">Invalid Date</span>
                        <span class="title mt-3 mb-2">To</span>
                        <div class="d-flex flex-row justify-content-between">
                            <select name="to day" id="to-day" class="form-control form-control-sm"
                                formControlName="toDay" (change)="validateDate()">
                                <option [value]="day" *ngFor="let day of toDaysDrop">{{day}}</option>
                            </select>
                            <select name="to month" id="to-month" class="form-control form-control-sm mx-2"
                                (change)="validateDate()" formControlName="toMonth">
                                <option [value]="month.no" *ngFor="let month of months">{{month.text}}</option>
                            </select>
                            <select name="to year" id="to-year" class="form-control form-control-sm"
                                (change)="validateDate()" formControlName="toYear">
                                <option [value]="year" *ngFor="let year of years">{{year}}</option>
                            </select>
                        </div>
                        <span *ngIf="toDateError" class="error">Invalid Date</span>
                        <div class="d-flex flex-row justify-content-end mt-5 mb-3">
                            <button class="btn btn-cancel mr-2" data-toggle="modal" data-dismiss="modal"
                                data-target="#booking-details">Cancel</button>
                            <button class="btn btn-theme"
                                [disabled]="!bookingForm.valid || fromDateError || toDateError"
                                (click)="updateBookingDates()">
                                <div class="d-flex flex-row justify-content-center">
                                    <div class="spinner-border loader" role="status" *ngIf="loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span class="align-self-center" *ngIf="!loading">Confirm</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- Approve Booking Dates Modal Ends -->